import { useEffect, useState, useContext, Fragment } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStyletron } from 'baseui';
import { Button, SHAPE, KIND } from 'baseui/button';

import { AppContext } from 'context';
import DrawerToggle from '../drawer-toggle';
import UserProfile from './user-profile';
import manImage from 'assets/icons/man.png';

type Props = {
  drawerToggleClicked: () => void;
};

const Toolbar = ({ drawerToggleClicked }: Props) => {
  const {
    state: { token },
  } = useContext(AppContext);
  const [css] = useStyletron();
  const location = useLocation();
  const navigate = useNavigate();
  const [isHomeRoute, setIsHomeRoute] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const parentWrapperStyles = css({
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '100vw',
    position: 'fixed',
    top: '0',
    left: '0',
    padding: '20px',
    zIndex: 200,
    background: scrolled ? '#00365a' : 'transparent',
    boxShadow: scrolled
      ? '0 1px 15px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)'
      : 'none',
  });

  useEffect(() => {
    setIsAuthenticated(token && token !== '');
  }, [token]);

  useEffect(() => {
    setIsHomeRoute(location.pathname === '/');
  }, [location.pathname]);

  const navigateToRoute = (route: string) => {
    navigate(route);
  };

  window.addEventListener('scroll', () => {
    setScrolled(window.scrollY >= 20);
  });

  return (
    <Fragment>
      <div className={parentWrapperStyles}>
        <div className={css({ display: 'flex', alignItems: 'center' })}>
          <div className={css({ marginRight: '40px', height: '40px' })}>
            <DrawerToggle clicked={drawerToggleClicked} />
          </div>
          <div
            className={css({
              cursor: isHomeRoute ? 'inherit' : 'pointer',
            })}
            onClick={() => {
              if (!isHomeRoute && !isAuthenticated) {
                navigateToRoute('/');
              }
            }}
          >
            <span className={css({ fontSize: '1.8rem', marginRight: '10px' })}>
              ES
            </span>
            <span className={css({ fontSize: '1.8rem', fontWeight: 'bold' })}>
              Campaign
            </span>
          </div>
        </div>
        <div
          className={css({
            display: 'flex',
            marginLeft: 'auto',
            marginRight: '24px',
          })}
        >
          {isHomeRoute && !isAuthenticated ? (
            <>
              <div className={css({ paddingRight: '10px' })}>
                <Button
                  kind={KIND.secondary}
                  shape={SHAPE.pill}
                  startEnhancer={() => (
                    <img
                      className={css({ width: '16px', height: '16px' })}
                      src={manImage}
                      alt="Sign in"
                    />
                  )}
                  onClick={() => navigateToRoute('auth/signIn')}
                >
                  Sign in
                </Button>
              </div>
              <div className={css({ paddingLeft: '10px' })}>
                <Button
                  shape={SHAPE.pill}
                  onClick={() => navigateToRoute('auth/signUp')}
                >
                  Sign up
                </Button>
              </div>
            </>
          ) : null}
          {isAuthenticated ? (
            <>
              <UserProfile />
            </>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default Toolbar;
